import styled from 'styled-components'

import { Dialog } from '@root/shared/ui-kit'

import { CurrencySelectorList } from '../common/currency-selector-list'

import type { CurrencySelectorListProps } from '../common/currency-selector-list'
import type { DialogControlProps } from '@root/shared/ui-kit'

type Props = {
  title: string
} & CurrencySelectorListProps &
  DialogControlProps

// TODO: Fix styles

export const CurrencySelectorDialog: React.FC<Props> = ({
  open,
  onOpenChange,
  title,
  ...props
}) => {
  return (
    <Root
      describedBy="currency-selector-dialog"
      open={open}
      onOpenChange={onOpenChange}
    >
      <Dialog.Header>{title}</Dialog.Header>
      <List {...props} />
    </Root>
  )
}

const Root = styled(Dialog)`
  width: 370px;
  height: 65vh;
`

const List = styled(CurrencySelectorList)`
  padding-top: 12px;
`
